/* eslint-disable */
export default {
  cancel: 'Annulla',
  reply: 'Rispondi',
  onMyWay: 'Sto arrivando',
  customMessage: 'Messaggio personalizzato',
  callMeBackIn: 'Richiamami tra',
  willCallYouBackIn: 'Ti richiamo tra',
  min: 'min',
  hours: 'ore',
  days: 'giorni',
} as const;

// @key: @#@"cancel"@#@ @source: @#@"Cancel"@#@
// @key: @#@"reply"@#@ @source: @#@"Reply"@#@
// @key: @#@"onMyWay"@#@ @source: @#@"On my way"@#@
// @key: @#@"customMessage"@#@ @source: @#@"Custom Message"@#@
// @key: @#@"callMeBackIn"@#@ @source: @#@"Call me back in"@#@
// @key: @#@"willCallYouBackIn"@#@ @source: @#@"Will call you back in"@#@
// @key: @#@"min"@#@ @source: @#@"min"@#@
// @key: @#@"hours"@#@ @source: @#@"hours"@#@
// @key: @#@"days"@#@ @source: @#@"days"@#@
